<template>
  <div>
    <div class="text-xs-right">
      <v-btn icon @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <div class="px-5 pb-4">
      <div v-if="loading" class="text-xs-center pb-3">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <div>เลข IMEI</div>
        <div class="form-control" :class="{ 'has-error': errors.has('IMEI') }">
          <multipleselect
            v-model="selectedImei"
            v-validate="'required'"
            name="IMEI"
            label="imei"
            :options="options"
          ></multipleselect>
          <span v-if="errors.has('IMEI')" class="text-error">{{ errors.first('IMEI') }}</span>
        </div>
        <div class="mt-3">
          <div class="caption">ข้อมูลเครื่อง</div>

          <div>{{ selectedImei.description ? selectedImei.description : '-' }}</div>
        </div>
        <div class="mt-3">
          <div class="caption">เครื่อง</div>
          <div>{{ selectedImei.points ? selectedImei.points : '-' }}</div>
        </div>
        <div class="text-center">
          <v-btn :loading="saveloading" depressed color="primary" @click="saveData"> บันทึก </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Multipleselect from 'vue-multiselect'

export default {
  components: {
    Multipleselect
  },
  props: ['datavalue'],
  computed: {
    ...mapGetters(['selectedBot'])
  },
  data() {
    return {
      loading: false,
      saveloading: false,
      selectedImei: '',
      options: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async saveData() {
      if (await this.$validator.validate()) {
        var data = {
          pageid: this.selectedBot.pageid,
          memberId: this.datavalue.id,
          imei: this.selectedImei.imei
        }
        this.saveloading = true
        api.createYasaleMemberPoint(data, async (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            await this.$swal.fire({
              text: 'สำเร็จ',
              type: 'success'
            })
            this.$emit('onsavecreate')
          } else {
            this.$swal.fire({
              text: response.reason
            })
          }
        })
      }
    },
    getData() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      this.loading = true
      api.getYasaleImeiAvailable(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          this.options = response.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/yasale/member/MemberPointDetailCreate.vue